import { BaseService } from "./base.service";
import { API_ENDPOINTS } from "../utils/endpoints";
import { SelectItem } from "primereact/selectitem";
import { HorseGroup } from "../queries/models/horse-group.model";

class HorseGroupsService extends BaseService {
  async getAllActive(): Promise<HorseGroup[]> {
    const url = `${this.endpointPath}/active`;
    return this.http.get<HorseGroup[]>(url).then((r: any) => r.data);
  }
  async getAllActiveAsOptions(): Promise<SelectItem[]> {
    const url = `${this.endpointPath}/active-as-options`;
    return this.http.get<SelectItem[]>(url).then((r: any) => r.data);
  }
  async add(request: HorseGroup) {
    const url = `${this.endpointPath}/create`;
    return this.http.post(url, request).then((r: any) => r.data);
  }
  async edit(request: HorseGroup) {
    const url = `${this.endpointPath}/update`;
    return this.http.put(url, request).then((r: any) => r.data);
  }
  async delete(id: number) {
    const url = `${this.endpointPath}/delete/${id}`;
    return this.http.delete(url).then((r: any) => r.data);
  }
}

export const horseGroupsService = new HorseGroupsService(API_ENDPOINTS.HORSE_GROUPS);
